import { defineDocStore } from '@/stores/base/baseDocStore'
import { IDDocumentModel } from '@/models/IDDocumentModel'
import type { IDDocument } from '@/types/IDDocument'

export const useIDDocumentStore = defineDocStore<IDDocument>({
  entityName: 'idDocument',
  collection: 'id_documents',
  model: IDDocumentModel,
  initialState: {
    filters: {
      global: { value: null, matchMode: 'contains' },
      personId: { value: null, matchMode: 'equals' },
      type: { value: null, matchMode: 'equals' },
    },
    sort: { field: 'updatedAt', order: -1 },
  },
})
